import {Props} from './model';
import {Field} from 'redux-form';
import {BaseField, BaseFieldProps} from '../../../../shared/components/baseField';
import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {multipleFormName, singleFormName} from '../../helpers';
import {PollQuestionType} from '../../../../shared/models/poll';
import {PollQuestionResponsePayload, PollAnswerResponsePayload} from '../../../../shared/models/api';

const BaseFieldWrapper = (props: BaseFieldProps) => {
  return (
    <BaseField
      {...{
        ...props,
        input: {
          ...props.input,
          value: props.type === 'checkbox' ? !!props.input.value : props.input.value,
        },
      }}
    />
  );
};

const getFieldName = (question: PollQuestionResponsePayload, answer: PollAnswerResponsePayload): string => {
  return question.typeId === PollQuestionType.manyAnswers
    ? `${multipleFormName}_${question.id}_${answer.id}`
    : `${singleFormName}_${question.id}`;
};

export default ({question, answer, disabled}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    answer: {
      borderStyle: 'solid',
      borderBottomColor: theme.color.borderColor,
      borderTopColor: theme.color.borderColor,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      marginTop: -1,
      padding: 20,
    },
    answerLabel: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light),
    },
  }));
  return (
    <View style={styles.answer}>
      <Field
        testIDprefix={`answer-${answer.id}-question-${question.id}`}
        component={BaseFieldWrapper}
        type={question.typeId === PollQuestionType.manyAnswers ? 'checkbox' : 'radio'}
        name={getFieldName(question, answer)}
        labelStyle={styles.answerLabel}
        label={answer.text}
        value={answer.id}
        disabled={disabled}
      />
    </View>
  );
};
